module.exports = "/images/Virtual reality.svg?4a30a4d7ea447393b12311f85e3e715d";